import React from 'react'

import { gql } from '@apollo/client'

import CreateTableObject from '../../../../components/BPMTable/TableComponents/TableWrapper/CreateTableObject'

import InvoiceContent from './InvoiceContentValidation'
import {Loading} from '../../../../components/Loading/Loading'

export function InvoiceValidationQuery(props) {
    const {match, TableCreator} = props

    const tableObject = CreateTableObject(TableCreator)

    // TODO: Aca se puede invocar un metodo del TableObject como to.getUnitQuery() no necesita contexto por que lo tiene en el propio to.
    const _QUERY = gql`
        query($id: String!) {
            ${TableCreator.unitQueryBuilder.toString()}
        }
    `
    return (
        <div>
            <Loading query={_QUERY} variables={{id: match.params.id}}>
                {(data, refetch) => {
                    return (
                        <div>
                            <InvoiceContent
                                data={tableObject.popupMapper(data)}
                                refetch={refetch}
                                TableObject={tableObject}
                                client={tableObject.client}
                            />
                        </div>
                    )
                }}
            </Loading>
        </div>
    )
}
